export class CalculoResultadoSimulacaoDTO {
  public promotora!: string;
  public empregador!: string;
  public financiamento!: string;
  public produto!: string;
  public valorRMC!: number;
  public valoresRMCRefin!: number | null;
  public valoresRMCCompraDivida!: number | null;
  
  public valorLimite!: number;
  public limiteCompra!: number;
  public limiteSaque!: number;
  public tarifaEmissao!: number;
  public anuidade!: number;
  public limiteSaqueDisplay!: number; 
  public fatorMultiplicadorRmcSaque!: number;
  public fatorMultiplicadorRmcCompra!: number;
  public valorMaximoLimiteCompra!: number;
  public valorMaxProdutoSaque!: number;
  public valorMaxProdutoCompra!: number;
  
  public dtNascimentoCliente!: Date;

  public prazos!: number[];
  public valorMaximoContratado!: number;
  public valorMinContratado!: number;
  public valorMinParcela!: number;
  public valorMaxParcela!: number;
}